/* eslint-disable no-template-curly-in-string */
import React from 'react';
import { template, isEqual, get, assign } from 'lodash';
import { Icons, BrandingIcons } from 'sarsaparilla';
import { FIELD_SALES_SALES_CHANNEL, CALL_CENTER_SALES_CHANNEL } from '../../../ui-field-sales/src/constants/types';
import { getLocationSalesUrl } from '../../../ui-field-sales/src/utilities/tabUtils';
import { ACTIVITY_PASS, REC_AREA } from './locations';

export const OPERATIONS = 'Operations';
export const INVENTORY_MANAGEMENT = 'Management';
export const USERS_AND_REPORTS = 'Admin';
export const launchBuckets = {
  [OPERATIONS]: 'Daily Operations',
  [INVENTORY_MANAGEMENT]: 'Inventory Management',
  [USERS_AND_REPORTS]: 'Administration',
};

const PARK_PASS_CONTENT_MANAGEMENT = 'PARK_PASS_CONTENT_MANAGEMENT';
export const domainToTileMap = {
  USER_MANAGEMENT: {
    path: '/internal/account/manage-users',
    text: 'User Management',
    icon: <Icons.IconPeopleOutline size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  CUSTOMER_SERVICE_REPRESENTATIVE: {
    path: '/internal/csr/',
    text: 'CSR Hub',
    icon: <Icons.IconPeopleOutline size="lg" />,
    bucket: OPERATIONS,
  },
  // This is a duplicate for PMOs and CSRs
  RESEARCH: {
    path: '/internal/csr/',
    text: 'Research',
    icon: <Icons.IconPeopleOutline size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  // FACILITY_WIDE: {
  //   path: '/internal/account/facility-wide', // TODO need to define this
  //   text: 'Facility Wide',
  //   icon: <Icons.IconMall size="lg" />
  // },
  FIELD_SALES: {
    path: '/internal/sales/field/${location_type}/${location_id}',
    text: 'Field Sales',
    icon: <Icons.IconAtm size="lg" />,
    bucket: OPERATIONS,
    salesChannel: FIELD_SALES_SALES_CHANNEL,
  },
  // ATR: {
  //   path: '/internal/account/atr', // TODO need to define this
  //   text: 'Field Sales',
  //   icon: <Icons.IconStarBorder size="lg" />
  // },
  COMMUNICATION: {
    path: '/internal/communication',
    text: 'Alerts & Communications',
    icon: <Icons.IconEmail size="lg" />,
    bucket: OPERATIONS,
  },
  PASS_DOWNLOAD: {
    path: '/internal/pass/requisitions-downloads',
    text: 'Interagency Pass Orders',
    icon: <Icons.IconFileDownload size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  PASS_HOME: {
    path: '/internal/pass',
    text: 'Interagency Annual Pass Requisitions',
    icon: <Icons.IconCard size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  POS_MANAGEMENT: {
    path: '/internal/pos/${location_type}/${location_id}/management', // POS
    text: 'Point of Sales Management',
    icon: <Icons.IconCog size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  DOMAIN_BAH_FINANCIAL: {
    path: '/internal/bahfinance',
    text: 'BAH Finance',
    icon: <Icons.IconAtm size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  FINANCIAL_TRANSACTION_MANAGEMENT: {
    path: '/internal/ftm',
    text: 'Finance',
    icon: <Icons.IconAtm size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  REPORTS: {
    path: '/internal/reporting',
    text: 'Reports',
    icon: <Icons.IconDescription size="lg" />,
    bucket: OPERATIONS,
  },
  // TRAINING: {
  //   path: '/internal/training', // TODO needs to be updated by other microservice team, when path exists
  //   text: 'Training',
  //   icon: <Icons.IconCog size="lg" />
  // },
  FEE_MANAGEMENT: {
    path: '/internal/${location_type}/${location_id}/fees',
    text: 'Season & Fee Management',
    icon: <Icons.IconCog size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  GEOFENCING_MANAGEMENT: {
    path: '/internal/geofencing/${location_id}',
    text: 'Geofencing Management',
    icon: <Icons.IconExplore size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  CAMPING_GATEWAY_MANAGEMENT: {
    path: '/internal/${location_type}/gateway/${location_id}',
    text: 'Gateway Management',
    icon: <Icons.IconTerrain size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  CAMPING_RESERVATION_MANAGEMENT: {
    path: '/internal/${location_type}/${location_id}/reservations',
    text: 'Camping Reservation Management',
    icon: <Icons.IconCalendar size="lg" />,
    bucket: OPERATIONS,
  },
  CAMPING_LOTTERY_CONFIGURATION: {
    path: '/internal/campinglottery/configuration/${location_id}',
    text: 'Camping Lottery Configuration',
    icon: <Icons.IconLottery size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  CAMPING_INVENTORY_MANAGEMENT: {
    path: '/internal/${location_type}/facilities/${location_id}',
    text: 'Camping Inventory Management',
    icon: <Icons.IconTent size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  PERMIT_RESERVATION_MANAGEMENT: {
    path: '/internal/${location_type}/${location_id}/reservations',
    text: 'Reservation Management',
    icon: <Icons.IconCheckCircle size="lg" />,
    bucket: OPERATIONS,
  },
  RENTAL_RESERVATION_MANAGEMENT: {
    path: '/internal/rentals/${location_id}/reservations',
    text: 'Rental Reservation Management',
    icon: <Icons.IconCheckCircle size="lg" />,
    bucket: OPERATIONS,
  },
  PERMIT_INVENTORY_MANAGEMENT: {
    path: '/internal/${location_type}/${location_id}/inventory',
    text: 'Inventory Management',
    icon: <Icons.IconTicket size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  PERMIT_LOTTERY_MANAGEMENT: {
    path: '/internal/${location_type}/${location_id}/lotteries',
    text: 'Lottery Management',
    icon: <BrandingIcons.Lottery size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  QUEUE_LOTTERY_MANAGEMENT: {
    path: '/internal/${location_type}/${location_id}/queuelotteries',
    text: 'Early Access Lottery Management',
    icon: <BrandingIcons.Lottery size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  TICKET_RESERVATION_MANAGEMENT: {
    path: '/internal/tickets/${location_id}/reservations',
    text: 'Reservation Management',
    icon: <Icons.IconCheckCircle size="lg" />,
    bucket: OPERATIONS,
  },
  TICKET_INVENTORY_MANAGEMENT: {
    path: '/internal/tickets/${location_id}/inventory',
    text: 'Inventory Management',
    icon: <Icons.IconTicket size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  TICKET_LOTTERY_MANAGEMENT: {
    path: '/internal/tickets/facility/${location_id}/lotteries',
    text: 'Lottery Management',
    icon: <BrandingIcons.Lottery size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  // TODO Bring this tile back when the service is available
  // DISCOUNT_MANAGEMENT: {
  //   path: '/internal/discounts/${location_id}/management',
  //   text: 'Discount Management',
  //   icon: <Icons.IconAtm size="lg" />,
  //   bucket: INVENTORY_MANAGEMENT
  // },
  PARK_PASS_INVENTORY_MANAGEMENT: {
    path: '/internal/passes-management/locations',
    text: 'Digital Pass Internal Management',
    icon: <Icons.IconCard size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  [PARK_PASS_CONTENT_MANAGEMENT]: {
    path: '/internal/${location_type}/content-management/${location_id}/general-information',
    text: 'Digital Pass Management',
    icon: <Icons.IconCard size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  PARK_PASS_RESERVATION_MANAGEMENT: {
    path: '/internal/parkpass/location-selection',
    text: 'Validation Scanner',
    icon: <Icons.IconCard size="lg" />,
    bucket: OPERATIONS,
  },
  SITE_PASS_RESERVATION_MANAGEMENT: {
    path: '/internal/scanner/parkpass/location-selection',
    text: 'Validation Scanner',
    icon: <Icons.IconCard size="lg" />,
    bucket: OPERATIONS,
  },
  ACTIVITY_PASS_RESERVATION_MANAGEMENT: {
    path: '/internal/activitypass/location-selection',
    text: 'Validation Scanner',
    icon: <Icons.IconCard size="lg" />,
    bucket: OPERATIONS,
  },
  SHIFT_HISTORY: {
    path: '/internal/shift/shift-history/${location_type}/${location_id}',
    text: 'Shift & Deposits',
    icon: <Icons.IconClock size="lg" />, // TODO: Right icon?
    bucket: OPERATIONS,
  },
  COMMERCIAL_MANAGEMENT: {
    path: '/internal/operators/companies',
    text: 'Commercial Management',
    icon: <Icons.IconConvenienceStore size="lg" />, // TODO: Right icon?
    bucket: USERS_AND_REPORTS,
  },
  CONCESSIONAIRES: {
    path: '/internal/account/manage-concessionaires',
    text: 'Concessionaires',
    icon: <Icons.IconSupervisorAccount size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  REQUEST_REFUND: {
    path: '/internal/refunds/reservations',
    text: 'Request Refund',
    icon: <Icons.IconRefund size="lg" />,
    bucket: OPERATIONS,
  },
  REFUND_REQUESTS: {
    path: '/internal/refunds/requests',
    text: 'Refund Requests',
    icon: <Icons.IconRefund size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  DOMAIN_COOPERATOR_MANAGEMENT: {
    path: '/internal/account/manage-cooperators',
    text: 'Cooperators',
    icon: <Icons.IconMood size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  DOMAIN_FACILITY_INFORMATION: {
    path: '/internal/account/facility-info/${location_type}/${location_id}',
    text: 'Facility Information',
    icon: <Icons.IconRecMenu size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  RATINGS_REVIEWS: {
    path: '/internal/rating-review',
    text: 'Ratings & Reviews',
    icon: <Icons.IconStarHalf size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  RATINGS_REVIEWS_APPROVAL_INBOX: {
    path: '/internal/rating-review/moderation',
    text: 'Ratings & Reviews Approval Inbox',
    icon: <Icons.IconStarHalf size="lg" />,
    bucket: OPERATIONS,
  },
  pos_path_for_map: {
    path: '/internal/sales/field/pos/${location_type}/${location_id}',
  },
  pass_path_for_map: {
    path: '/internal/sales/field/pass/${location_type}/${location_id}',
  },
  ccs_path_for_map: {
    path: '/internal/sales/call-center/${location_type}/${location_id}',
  },
  reservation_management: {
    path: '/internal/${location_type}/${location_id}/reservations',
  },
  DOMAIN_PERMIT_CONTENT: {
    path: '/internal/${location_type}/${location_id}/content',
    text: 'Content Management',
    icon: <Icons.IconDashboard size="lg" />,
    bucket: INVENTORY_MANAGEMENT,
  },
  QRCODE_MANAGEMENT: {
    path: '/internal/qr-codes/management',
    text: 'QR Management',
    icon: <Icons.IconQrCode size={'lg'} />,
    bucket: INVENTORY_MANAGEMENT,
  },
  DOMAIN_TREE_PERMIT_INTERNAL_MANAGEMENT: {
    path: '/internal/tree-permits/locations-management',
    text: 'Tree Permit Internal Management',
    icon: <Icons.IconTree size={'lg'} />,
    bucket: USERS_AND_REPORTS,
  },
  DOMAIN_XMAS_TREE_PERMIT_MANAGEMENT: {
    path: '/internal/tree-permits/inventory-management/${location_id}',
    text: 'Christmas Tree Permit Management',
    icon: <Icons.IconTree size={'lg'} />,
    bucket: INVENTORY_MANAGEMENT,
  },
  DOMAIN_LICENSE_PLATE_READER: {
    path: '/internal/timed-entry/lpr',
    text: 'License Plate Readers',
    icon: <Icons.IconCamera size={'lg'} />,
    bucket: USERS_AND_REPORTS,
  },
  DOMAIN_GIS_DATA: {
    path: '/internal/camping/${location_id}/gis/upload',
    text: 'GIS Data',
    icon: <Icons.IconPinDrop size={'lg'} />,
    bucket: INVENTORY_MANAGEMENT,
  },
  DOMAIN_CAMPING_BULK_CLOSURES_MANAGEMENT: {
    path: '/internal/camping/bulk_facilities/${location_id}',
    text: 'Bulk Facilities Management',
    icon: <Icons.IconCalendarBusy size={'lg'} />,
    bucket: INVENTORY_MANAGEMENT,
  },
  DOMAIN_DESTINATIONS: {
    path: '/internal/destinations/management',
    text: 'Destinations Management',
    icon: <Icons.IconDirections size={'lg'} />,
    bucket: INVENTORY_MANAGEMENT,
  },
  DOMAIN_MARKETING: {
    path: '/internal/marketing/qr-code-generator',
    text: 'Marketing Resources & Tools',
    icon: <Icons.IconAtm size="lg" />,
    bucket: USERS_AND_REPORTS,
  },
  DOMAIN_DNC_MANAGEMENT: {
    path: '/internal/communication/dnc',
    text: 'DNC Management',
    icon: <Icons.IconPhone size={'lg'} />,
    bucket: USERS_AND_REPORTS,
  },
};

const swapEncode = (obj) => {
  const ret = {};
  Object.keys(obj).forEach((key) => {
    ret[obj[key]] = key;
  });

  return ret;
};

export const encodeLocTypeUrlKeyMap = {
  Root: 'root',
  Campground: 'camping',
  Permit: 'permits',
  'Ticket Facility': 'tickets',
  'Vehicle Permit': 'vehiclepermit',
  'Activity Pass': 'activitypass',
  'Tree Permit': 'treepermit',
  'Timed Entry': 'timed-entry',
};

export const decodeLocTypeUrlKeyMap = Object.assign({}, swapEncode(encodeLocTypeUrlKeyMap), {
  permit: 'Permit',
  ticket: 'Ticket Facility',
  recarea: 'Rec Area',
  vehiclepermit: 'Vehicle Permit',
  activitypass: 'Activity Pass',
  treepermit: 'Tree Permit',
  'timed-entry': 'Timed Entry',
});

export const encodeLocTypePath = (location) => {
  if (location.has_park_pass) {
    return 'parkpass';
  }

  const key = location.location_type;
  return encodeLocTypeUrlKeyMap[key] || key;
};

export const generateTilePath = (tile, location) => {
  const compiled = template(tile.path);
  if (
    isEqual(get(tile, 'salesChannel'), FIELD_SALES_SALES_CHANNEL) ||
    isEqual(get(tile, 'salesChannel'), CALL_CENTER_SALES_CHANNEL)
  ) {
    const { location_type, location_id } = location;
    let tabLocation = location_type;
    if (location.has_park_pass && isEqual(get(tile, 'salesChannel'), FIELD_SALES_SALES_CHANNEL)) {
      tabLocation = 'pass';
    }
    if (tabLocation === 'Activity Pass') {
      tabLocation = 'activitypass';
    }
    return getLocationSalesUrl(tabLocation, location_id, tile.salesChannel, location.location_type);
  }
  // Hardcoding it here to 'camping' for gateway because its location_type is 'Rec Area' which will result
  // into an error when it tries to redirect to that page
  else if (isEqual(get(tile, 'path'), domainToTileMap.CAMPING_GATEWAY_MANAGEMENT.path)) {
    return compiled(
      assign({}, location, {
        location_type: 'camping',
      })
    );
  } else if (
    isEqual(get(tile, 'path'), domainToTileMap.PARK_PASS_RESERVATION_MANAGEMENT.path) &&
    location?.location_type === ACTIVITY_PASS
  ) {
    return domainToTileMap.ACTIVITY_PASS_RESERVATION_MANAGEMENT.path;
  }

  return compiled(
    assign({}, location, {
      location_type: encodeLocTypePath(location),
    })
  );
};

export const generateTileText = (tile, location) => {
  if (isEqual(domainToTileMap[PARK_PASS_CONTENT_MANAGEMENT], tile)) {
    switch (location?.location_type) {
      case ACTIVITY_PASS:
        return 'Activity Pass Management';
      case REC_AREA:
        return 'Site Pass Management';
      default:
        return tile?.text;
    }
  }

  return tile?.text;
};
